





























































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { UniteYMDHms } from '@/filters/index'
import { post, get } from '@/unite/api'
import { TableType } from './types.d'

const t = new Date()
  .valueOf()
  .toString()
  .substr(0, 10)
const token = sessionStorage.getItem('Apk-Jwt-Token')
@Component({
  components: {},
  filters: { UniteYMDHms }
})
export default class SearchPaginationTable extends Vue {
  @Prop() pageData: any
  data: TableType[] = []
  current: any = 0
  pageSizeArr: any[] = [10, 20, 40, 100]
  pageSize: any = 10
  countData: number = 0
  loading: boolean = false
  pickerOptions: any = {
    shortcuts: [
      {
        text: '今天',
        onClick(picker: any) {
          picker.$emit('pick', new Date())
        }
      },
      {
        text: '昨天',
        onClick(picker: any) {
          const date = new Date()
          date.setTime(date.getTime() - 3600 * 1000 * 24)
          picker.$emit('pick', date)
        }
      },
      {
        text: '一周前',
        onClick(picker: any) {
          const date = new Date()
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', date)
        }
      }
    ]
  }
  created() {
    const signString = JSON.stringify(this.pageData.info) + t + token
    this.getData()
  }
  // todo 获取列表数据
  getData() {
    this.loading = true
    post(this.pageData.url, this.pageData.info)
      .then(d => {
        this.data = d.data.items
        // @ts-ignore
        this.countData = Number(d.data.page.total)
        this.data.forEach(item1 => {
          // @ts-ignore
          this.pageData.tableData.header.forEach(item2 => {
            if (item2.status) {
              // @ts-ignore
              item1[item2.prop] = item2.status[item1[item2._prop]]
            }
          })
        })
        // console.log(this.data)
        // //console.log(this.data)
        this.loading = false
      })
      .catch(e => {
        this.loading = false
      })
  }
  // todo 操作
  // 搜索
  private search() {
    this.pageSize = this.pageData.info.pagination.page_size
    this.getData()
  }
  public btnClick(methods: string) {
    if (methods === 'refesh') {
      this.getData()
    } else {
      this.$emit('btnClick', methods)
    }
  }
  // 操作事件
  public handleClick(methods: string, row: any) {
    this.$emit('handleClick', methods, row)
  }
  // todo 分页触发事件
  handleCurrentChange(val: number) {
    this.current = val
    this.pageData.info.pagination.page = val
    this.getData()
  }
  handleSizeChange(val: number) {
    this.pageSize = val
    this.pageData.info.pagination.page_size = val
    this.getData()
  }
}
